import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  contactsRoot: {
    paddingBlock: 10,
    flexGrow: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },

  linksLabel: {
    fontSize: '1rem',
    lineHeight: '26px',
    fontWeight: 600,
  },

  link: {
    color: 'white',
    fontSize: '1rem',
    lineHeight: '26px',
    fontWeight: 600,
  },

  bannerWrapper: {
    paddingBlock: '1rem',
    alignItems: 'center',
    backgroundColor: '#e7e9ea',
  },

  banner: {
    height: 'auto',
    width: 'auto',
    display: 'inline-block',
    [theme.breakpoints.up('md')]: {
      height: 60,
    },
  },

  credits: {
    minWidth: 160,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
}));
